import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCardTitle,[_vm._v(" "+_vm._s(_vm.set_post.title)+" ")]),_c(VDivider,{staticClass:"mx-2"}),_c(VCardText,{staticClass:"text-center"},[_c(VRow,[_c(VCol,[_c('div',{staticClass:"aspect-ratio-16x9"},[_c('iframe',{attrs:{"width":"600","height":"340","src":'https://www.youtube.com/embed/'+_vm.set_post.youtube_code,"frameborder":"0","allowfullscreen":""}})])])],1)],1),_c(VDivider,{staticClass:"mx-2"}),_c(VCardText,{domProps:{"innerHTML":_vm._s(_vm.contentQuill)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }